import * as z from "zod/v4";

const serviceMappingInputSchema = z.object({
  carrier: z.string(),
  service: z.string().optional(),
  netsuiteShipItemId: z.string(),
  subsidiaryId: z.string().optional(),
});

const addressInputSchema = z.object({
  name: z.string().nullish(),
  address1: z.string().nullish(),
  address2: z.string().nullish(),
  company: z.string().nullish(),
  city: z.string().nullish(),
  province: z.string().nullish(),
  zip: z.string().nullish(),
  countryCode: z.string().nullish(),
  phone: z.string().nullish(),
  email: z.string().nullish(),
});

export const updateOmsNetsuiteIntegration = {
  name: "updateOmsNetsuiteIntegration" as const,
  input: z.object({
    serviceMappings: z.array(serviceMappingInputSchema).nullish(),
    defaultShipItemId: z.string().nullish(),
    shippingCostField: z.string().nullish(),
    fallbackAddress: addressInputSchema.nullish(),
    customSkuField: z.string().nullish(),
    customWeightField: z.string().nullish(),
    customTitleField: z.string().nullish(),
    secondaryOrderNameField: z.string().nullish(),
    externalSearchIdField: z.string().nullish(),
    ownPackageField: z.string().nullish(),
    timezone: z.string().nullish(),
  }),
  output: z.object({ success: z.boolean() }),
};
